import { MenuPermission, PermissionType, User, UserSystemAttributes } from '../../domain/rbac/RbacDomains';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { AccessBase } from '../../domain/access/BaseAccess';
import { UserActions } from '../actions/UserActions';

export interface AuthState {
  user: User | null;
  permissions: MenuPermission[];
  access:
    | {
        component: AccessBase;
        role: PermissionType;
      }
    | undefined;
  attributes: UserSystemAttributes;
}

const initialState: AuthState = {
  user: null,
  permissions: [],
  access: undefined,
  attributes: {
    id: '',
    username: '',
    filters: [],
    table: [],
    tabOrders: [],
  },
};

export const authReducer = (state = initialState, action: ReduxBaseAction<any, UserActions>) => {
  switch (action.type) {
    case 'SET_USER':
      return {
        ...state,
        user: action.payload,
      };
    case 'SET_PERMISSIONS':
      return {
        ...state,
        permissions: action.payload,
      };
    case 'SET_ACCESS':
      return {
        ...state,
        access: action.payload,
      };
    case 'SET_ATTRIBUTE':
      return {
        ...state,
        attributes: action.payload,
      };
    default:
      return state;
  }
};
